/**
 * @author       sam@zumper.com (Sam Sherman)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail nearby meta reducer
 */

import { falseReducer, nullReducer, payloadKeyReducer, trueReducer } from '@zcode/reducers'
import type { NearbyWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CLEAR_NEARBY,
  DONE_FETCHING_NEARBY,
  ERROR_FETCHING_NEARBY,
  RECEIVE_NEARBY,
  START_FETCHING_NEARBY,
} from '../constants/index'
import type { ActionTypes } from './types'

type Meta = NearbyWithMeta['meta']

export const meta = combineReducers<Meta, ActionTypes>({
  error: handleActions<Meta['error'], ActionTypes>(
    {
      [ERROR_FETCHING_NEARBY]: payloadKeyReducer('error'),
      [CLEAR_NEARBY]: nullReducer,
      [START_FETCHING_NEARBY]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_NEARBY]: trueReducer,
      [CLEAR_NEARBY]: falseReducer,
      [DONE_FETCHING_NEARBY]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<Meta['fetchingKey'], ActionTypes>(
    {
      [START_FETCHING_NEARBY]: payloadKeyReducer('key'),
      [CLEAR_NEARBY]: nullReducer,
      [DONE_FETCHING_NEARBY]: nullReducer,
    },
    null
  ),
  currentKey: handleActions<Meta['currentKey'], ActionTypes>(
    {
      [CLEAR_NEARBY]: nullReducer,
      [RECEIVE_NEARBY]: payloadKeyReducer('key'),
    },
    null
  ),
})
